/* src/app/components/signup/signup.component.scss */
:host {
  display: block;
  min-height: 100vh;
}
.signup-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(
      circle at 8% 8%,
      rgba(37, 59, 128, 0.07),
      transparent 28%),
    radial-gradient(
      circle at 92% 92%,
      rgba(52, 79, 145, 0.06),
      transparent 28%),
    #F4F6FA;
}
.signup-shell {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 50% 50%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.1), 0 4px 16px rgba(15, 23, 42, 0.04);
}
.signup-visual {
  position: relative;
  overflow: hidden;
  background: #dfe8fa;
  color: #ffffff;
}
.signup-visual::before {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  top: -180px;
  left: -180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.signup-visual::after {
  content: "";
  position: absolute;
  width: 360px;
  height: 360px;
  right: -170px;
  bottom: -170px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
}
.visual-content {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 28px;
  display: flex;
  flex-direction: column;
}
.visual-brand {
  display: flex;
  align-items: center;
}
.visual-brand img {
  width: 225px;
  max-width: 100%;
  height: auto;
  filter: brightness(0) invert(1);
}
.visual-image {
  flex: 1;
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
}
.visual-image img {
  width: 100%;
  max-width: 440px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.12));
}
.visual-footer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 20px;
}
.visual-footer span {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  color: #253b80;
}
.visual-footer i {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}
.signup-panel {
  background: #ffffff;
  overflow-y: auto;
}
.signup-content {
  width: min(620px, 100%);
  min-height: 100%;
  margin: 0 auto;
  padding: 13px 64px 42px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mobile-brand {
  margin-bottom: 32px;
}
.mobile-brand img {
  width: 250px;
  height: auto;
}
.signup-header {
  margin-bottom: 30px;
}
.signup-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.4;
  color: #253B80;
  letter-spacing: 0.02em;
}
.signup-header h2 {
  margin: 0 0 9px;
  font-family: "Outfit";
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
}
.signup-header p {
  margin: 0;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.55;
  color: #6B7280;
}
.signup-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 13px 14px;
  border: 1px solid rgba(220, 38, 38, 0.18);
  border-radius: 10px;
  background: #fef2f2;
}
.alert-icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #dc2626;
}
.alert-icon i {
  font-size: 16px;
}
.alert-message {
  flex: 1;
  padding-top: 2px;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.45;
  color: #991b1b;
}
.alert-close {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #991b1b;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.alert-close:hover {
  background: rgba(220, 38, 38, 0.08);
}
.signup-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.form-field {
  min-width: 0;
}
.form-field label {
  display: block;
  margin-bottom: 9px;
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #111827;
}
.form-field label span {
  margin-left: 2px;
  color: #dc2626;
}
.input-wrapper {
  position: relative;
}
.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  font-size: 15px;
  color: #94a3b8;
  pointer-events: none;
  transition: color 0.2s ease;
}
.form-input {
  width: 100%;
  height: 46px;
  padding: 0 14px 0 42px;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  background: #ffffff;
  color: #111827;
  font-family: "Outfit";
  font-size: 14px;
  line-height: 1.4;
  outline: none;
  box-sizing: border-box;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}
.form-input::placeholder {
  color: #9ca3af;
  opacity: 1;
}
.form-input:hover {
  border-color: #aeb8c8;
}
.form-input:focus {
  border-color: #253B80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.input-wrapper:focus-within .input-icon {
  color: #253B80;
}
.form-input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
}
.signup-button {
  width: 100%;
  height: 48px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 0;
  border-radius: 9px;
  background: #253B80;
  color: #ffffff;
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 5px 12px rgba(37, 59, 128, 0.18);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.signup-button:hover:not(:disabled) {
  background: #1e316d;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(37, 59, 128, 0.22);
}
.signup-button:active:not(:disabled) {
  transform: translateY(0);
}
.signup-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
.signup-button i {
  font-size: 14px;
}
.signup-button.loading {
  cursor: wait;
  opacity: 0.85;
}
.spinner-border {
  width: 17px;
  height: 17px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: signup-spinner 0.7s linear infinite;
}
@keyframes signup-spinner {
  to {
    transform: rotate(360deg);
  }
}
.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 5px;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.5;
  color: #6B7280;
}
.login-link {
  font-family: "Outfit";
  font-size: 15px;
  font-weight: 600;
  color: #253B80;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
.login-link:hover {
  color: #1e316d;
  text-decoration: underline;
}
.signup-security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 18px;
  padding-top: 17px;
  border-top: 1px solid #eef2f7;
  font-family: "Outfit";
  font-size: 12px;
  line-height: 1.4;
  color: #9CA3AF;
}
.signup-security i {
  font-size: 12px;
  color: #64748b;
}
@media (max-width: 1024px) {
  .signup-page {
    padding: 24px;
  }
  .signup-shell {
    grid-template-columns: 40% 60%;
  }
  .visual-content {
    padding: 32px;
  }
  .signup-content {
    padding: 48px 42px 36px;
  }
  .signup-header h2 {
    font-size: 28px;
  }
  .form-row {
    gap: 14px;
  }
}
@media (max-width: 800px) {
  .signup-page {
    padding: 20px;
  }
  .signup-shell {
    grid-template-columns: 1fr;
    min-height: auto;
    max-width: 650px;
  }
  .signup-visual {
    display: none;
  }
  .signup-panel {
    overflow: visible;
  }
  .signup-content {
    width: 100%;
    min-height: auto;
    padding: 42px 40px 36px;
  }
  .mobile-brand {
    display: block;
    margin-bottom: 32px;
  }
}
@media (max-width: 600px) {
  .signup-page {
    min-height: 100vh;
    padding: 0;
    align-items: stretch;
  }
  .signup-shell {
    width: 100%;
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .signup-content {
    padding: 30px 22px 28px;
  }
  .mobile-brand {
    margin-bottom: 28px;
  }
  .mobile-brand img {
    width: 145px;
  }
  .signup-header {
    margin-bottom: 26px;
  }
  .signup-eyebrow {
    font-size: 12px;
    margin-bottom: 8px;
  }
  .signup-header h2 {
    font-size: 26px;
    line-height: 1.25;
  }
  .signup-header p {
    margin-top: 8px;
    font-size: 14px;
  }
  .signup-form {
    gap: 18px;
  }
  .form-row {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .form-field label {
    font-size: 13px;
  }
  .form-input {
    height: 48px;
    font-size: 14px;
  }
  .signup-button {
    height: 49px;
    font-size: 14px;
  }
  .login-section {
    flex-wrap: wrap;
    font-size: 13px;
  }
}
@media (max-width: 380px) {
  .signup-content {
    padding: 26px 18px 24px;
  }
  .signup-header h2 {
    font-size: 24px;
  }
  .signup-header p {
    font-size: 13px;
  }
  .form-input {
    height: 46px;
  }
  .signup-button {
    height: 47px;
  }
}
/*# sourceMappingURL=signup.component.css.map */
